define(["marionette", "./template/standardResponseHeaderTemplate.html"], function (
  Marionette,
  StandardResponseHeaderTemplate,
) {
  "use strict";

  const StandardResponseHeaderView = {};

  StandardResponseHeaderView.view = Marionette.ItemView.extend({
    template: StandardResponseHeaderTemplate,
    className: "row-fluid",
    modelEvents: {
      change: "render",
    },
    triggers: {
      "click #publishAllDropdown": "publishAll",
      "click #publishSelectedDropdown": "publishSelected",
    },
  });

  return StandardResponseHeaderView;
});
